import React from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { shareUrls } from "@/lib/utils_gg";

export const nativeShare = async (event) => {
  if (navigator.share && window.matchMedia("(pointer: coarse)").matches) {
    try { await navigator.share({ title: event.name, url: shareUrls(event).url }); return true; } catch (err) { if (err?.name === "AbortError") return true; console.warn("native share failed", err); }
  }
  return false;
};

export default function ShareDialog({ event, onClose }) {
  const { t } = useApp();
  const s = shareUrls(event);
  const stop = e => { e.stopPropagation(); e.preventDefault(); };
  const shareVia = async (app) => {
    const text = `${event.name} — ${event.city}, ${event.country} ${s.preview}`;
    if (navigator.share) { try { await navigator.share({ title: event.name, text: `${event.name} — ${event.city}, ${event.country}`, url: s.preview }); onClose(); return; } catch { return; } }
    await navigator.clipboard.writeText(text); toast.info(t("shareCopiedHint", { app: app === "signal" ? "Signal" : t("smsMessages") })); onClose();
  };
  const copyLink = async () => { try { await navigator.clipboard.writeText(s.url); toast.success(t("linkCopied")); } catch { toast.error(t("copyFailed")); } onClose(); };
  const shareInstagram = async () => {
    try { await navigator.clipboard.writeText(s.url); toast.success(t("instagramHint")); } catch (err) { console.warn("clipboard failed", err); toast.error(t("copyFailed")); }
    window.open(s.instagram, "_blank", "noopener");
    onClose();
  };
  const ext = { target: "_blank", rel: "noreferrer noopener", onClick: e => e.stopPropagation() };
  return createPortal(
    <div className="fixed inset-0 z-50 bg-black/60 flex items-end sm:items-center justify-center p-0 sm:p-6" onClick={e => { stop(e); onClose(); }} data-testid="share-dialog">
      <div onClick={e => e.stopPropagation()} className="gg-card bg-background p-5 sm:p-6 w-full sm:max-w-md">
        <div className="flex items-center justify-between"><h3 className="font-display uppercase text-2xl">{t("share")}</h3><button onClick={onClose} className="gg-icon-btn" data-testid="share-close"><X className="w-5 h-5" /></button></div>
        <p className="mt-1 text-sm text-muted-foreground truncate" data-testid="share-event-name">{event.name}</p>
        <div className="mt-4 flex flex-col gap-2">
          <button onClick={copyLink} className="gg-btn-primary" data-testid="share-copy">{t("copyLink")}</button>
          <a href={s.whatsapp} {...ext} className="gg-btn" data-testid="share-whatsapp">WhatsApp</a>
          <a href={s.facebook} {...ext} className="gg-btn" data-testid="share-facebook">Facebook</a>
          <button onClick={shareInstagram} className="gg-btn" data-testid="share-instagram">Instagram</button>
          <a href={s.mail} className="gg-btn" onClick={e => e.stopPropagation()} data-testid="share-mail">{t("email")}</a>
          <button onClick={() => shareVia("signal")} className="gg-btn" data-testid="share-signal">Signal</button>
          <a href={s.sms} className="gg-btn" onClick={e => e.stopPropagation()} data-testid="share-sms">{t("smsMessages")}</a>
        </div>
      </div>
    </div>, document.body);
}
